import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateModelField from '@shared/fields/date-model-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import StringArrayField from '@shared/fields/string-array-field';
import EnumeratorField from '@shared/fields/enumerator-field';
import DateRangeField from '@shared/fields/date-range-field';
import { CategoryField } from '@modules/category/category-field';
import { LocationField } from '@modules/location/location-field';
import { SeasonField } from '@modules/season/season-field';
import { UserField } from '@modules/auth/user-field';
import EmailsField from '@shared/fields/emails-field';
import getSharedEnumeratorField from '@shared/fields/helpers/getSharedEnumeratorField';
import SubprogramTryoutField from '@modules/subprogram/subprogram-tryout-field'
import SubprogramPaymentField from '@modules/subprogram/subprogram-payment-field'
import SubprogramAdditionalDocField from '@modules/subprogram/subprogram-additional-doc-field'
import { SubprogramRegularSeasonRoundsField } from '@modules/subprogram/subprogram-regular-season-rounds-field'
import BooleanField from '@shared/fields/boolean-field';

function label(name) {
    return i18n(`entities.subprogram.fields.${name}`);
}


const fields = ({ dateFormat }) => ({
    id: new IdField('id', label('id')),
    // ******************************************************
    // Step 1

    name: new StringField('name', label('name'), { required: true }),

    // category: CategoryField.relationToOne('category', label('category'), {}),
    category: CategoryField.relationToOne('category', label('categoryName'), { required: true }),

    season: SeasonField.relationToOne('season', label('season'), { required: true }),

    gender: new EnumeratorField('gender', label('gender'), getSharedEnumeratorField('gender'), { required: true }),

    regularSeasonHasRounds: new BooleanField('regularSeasonHasRounds', label('regularSeasonHasRounds'), { required: true }),
    regularSeasonRounds: new SubprogramRegularSeasonRoundsField('regularSeasonRounds', label('regularSeasonRounds')),

    startDate: new DateModelField('startDate', label('startDate'), {
        format: 'MMM Do',
        "required": true,
        dateFormat, 
    }),

    endDate: new DateModelField('endDate', label('endDate'), {
        format: 'MMM Do',
        "required": true,
        dateFormat, 
    }),

    dateRange: new DateTimeRangeField('dateRange', label('dateRange'), { 
        required: true,
     }),

    // ******************************************************
    // Step 2

    locations: LocationField.relationToMany('locations', label('locations'), { required: true }),

    tryout: new SubprogramTryoutField('tryout', label('tryout.title')),

    payment: new SubprogramPaymentField('payment', label('payment.title')),

    additionalDoc: new SubprogramAdditionalDocField('additionalDoc', label('additionalDoc.title')),

    identDocNeeded: new BooleanField('identDocNeeded', label('identDocNeeded'), {
        required: true
    }),
    competitions: new StringArrayField('competitions', label('competitions.label'), {}),

    // ******************************************************
    // Step 3

    // ******************************************************
    // Step 4
    emails: new EmailsField('emails', label('emails'), {}),

    managers: UserField.relationToMany('managers', label('managers'), {}),

    status: new EnumeratorField('status', label('status'), getSharedEnumeratorField('subprogramStatus'), { required: true }),

    createdAt: new DateTimeField(
        'createdAt',
        label('createdAt'),
    ),
    updatedAt: new DateTimeField(
        'updatedAt',
        label('updatedAt'),
    ),
    createdAtRange: new DateTimeRangeField(
        'createdAtRange',
        label('createdAtRange'),
    ),
    startDateRange: new DateRangeField(
        'startDateRange',
        label('startDateRange'),
    ),
    endDateRange: new DateRangeField(
        'endDateRange',
        label('endDateRange'),
    ),
    regStartDateRange: new DateRangeField(
        'regStartDateRange',
        label('regStartDateRange'),
    ),
    regEndDateRange: new DateRangeField(
        'regEndDateRange',
        label('regEndDateRange'),
    )
});

export class SubprogramModel extends GenericModel {
    constructor({ dateFormat } = {}) {
        super();

        this.dateFormat = dateFormat;
    }

    fields() {
        const { dateFormat } = this;
        return fields({ dateFormat });
    }

    presenter(row, fieldName) {
        const fields = this.fields();

        if (!fields[fieldName]) {
            throw new Error(`${fieldName} not found`);
        }

        return fields[fieldName].forPresenter(
            row[fields[fieldName].name],
        );
    }
}